import { render, staticRenderFns } from "./parkList.vue?vue&type=template&id=68e8edf4&scoped=true"
import script from "./parkList.vue?vue&type=script&lang=js"
export * from "./parkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e8edf4",
  null
  
)

export default component.exports